module.exports = __webpack_public_path__ + "static/initials-26909ff7b49a8b5bf8e321533689794b.png";